"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AnnotationUtil = /*#__PURE__*/function () {
  function AnnotationUtil() {
    _classCallCheck(this, AnnotationUtil);
  }

  _createClass(AnnotationUtil, null, [{
    key: "createCanvasForElement",
    value:
    /**
     * Create a canvas element with dimensions and offset of the reference element
     * @param {Element} element
     * @param {boolean} append
     * @param {boolean} insert
     * @returns {Element}
     */
    function createCanvasForElement(element, devicePixelRatio) {
      var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var insert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var canvas = document.createElement('canvas');
      var rect = element.getBoundingClientRect();
      var canvasTop = 0;
      var canvasLeft = 0;

      if (insert) {
        canvasLeft = "".concat(element.offsetLeft, "px");
        canvasTop = "".concat(element.offsetTop, "px");
      }

      canvas.style.position = 'absolute';
      canvas.style.top = canvasTop;
      canvas.style.left = canvasLeft;
      canvas.style.width = "".concat(rect.width, "px");
      canvas.style.height = "".concat(rect.height, "px");
      canvas.width = rect.width * devicePixelRatio;
      canvas.height = rect.height * devicePixelRatio;

      if (insert && append) {
        element.appendChild(canvas);
      } else if (insert) {
        element.parentNode.insertBefore(canvas, element.nextSibling);
      }

      return canvas;
    }
  }]);

  return AnnotationUtil;
}();

exports["default"] = AnnotationUtil;